import React, { memo, useCallback, useMemo } from 'react';
import { RichUtils } from 'draft-js';
import cn from 'classnames';
import { useValueRef } from '../../hooks/useValueRef';
import Toolbar from './components/Toolbar';
import Editor from './components/Editor';
import { Provider } from './provider';
import LinkModal from './components/LinkModal';
import PhoneLinkModal from './components/PhoneLinkModal';
import { toolbarBlockNames } from './config';
import styles from './Main.module.scss';

const MemoizedToolbar = memo(Toolbar);
const defaultToolNames = Object.values(toolbarBlockNames);

const DspxEditor = ({
  value,
  onChange: changeHandler,
  onClose,
  autoFocus = false,
  toolNames = defaultToolNames,
  className,
}) => {
  const propsRef = useValueRef({ value, onChange: changeHandler });

  const getEditorState = useCallback(() => propsRef.current.value, [propsRef]);

  const onChange = useCallback(
    (state) => {
      const hasText = state.getCurrentContent().hasText();
      propsRef.current.onChange(hasText ? state : resetBlockType(state));
    },
    [propsRef]
  );

  const actions = useMemo(
    () => ({ onChange, getEditorState }),
    [onChange, getEditorState]
  );

  return (
    <Provider value={value} actions={actions}>
      <div className={cn(styles.root, className)}>
        <MemoizedToolbar
          onClose={onClose}
          className={styles.toolbar}
          toolList={toolNames}
        />
        <Editor autoFocus={autoFocus} className={styles.editor} />
      </div>
      <LinkModal />
      <PhoneLinkModal />
    </Provider>
  );
};

DspxEditor.toolNames = toolbarBlockNames;

export default DspxEditor;

function resetBlockType(state) {
  const contentState = state.getCurrentContent();
  const startKey = state.getSelection().getStartKey();
  const blockType = contentState.getBlockForKey(startKey).getType();

  if (blockType.startsWith('header')) {
    return RichUtils.toggleBlockType(state, 'unstyled');
  }

  return state;
}
